export enum Role {
  encoder = 1,
  publisher = 2,
}
